document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantes();
  initNewsletter();
  initMuestrasColor();
  initGuiaTallas();
  initCartUpsell();
});

function initCartUpsell() {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mt-upsell-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-mt-upsell-add');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: 'cart-drawer,cart-icon-bubble' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections) {
          drawer.renderContents({ sections: data.sections });
        }
      })
      .catch(function () {
        window.location.href = '/cart';
      })
      .finally(function () {
        btn.disabled = false;
      });
  });
}

function initGuiaTallas() {
  document.querySelectorAll('[data-mt-guia-toggle]').forEach(function (btn) {
    var grupo = btn.closest('[data-mt-opcion]');
    var panel = grupo ? grupo.querySelector('[data-mt-guia-panel]') : null;
    var icono = btn.querySelector('[data-mt-guia-icono]');
    if (!panel) return;
    btn.addEventListener('click', function () {
      var abierto = !panel.hidden;
      panel.hidden = abierto;
      btn.setAttribute('aria-expanded', String(!abierto));
      if (icono) icono.textContent = abierto ? '+' : '−';
    });
  });
}

function initMuestrasColor() {
  var diccionario = {
    "negro": "#141414", "black": "#141414",
    "blanco": "#FFFFFF", "white": "#FFFFFF",
    "gris": "#9B9B9B", "gray": "#9B9B9B", "grey": "#9B9B9B",
    "gris claro": "#D4D4D4", "gris oscuro": "#5A5A5A", "gris marfil": "#DAD6CE", "gris pizarra": "#6E7A82",
    "azul": "#2E5FA3", "blue": "#2E5FA3",
    "azul marino": "#1B2A4A", "marino": "#1B2A4A", "navy": "#1B2A4A",
    "azul claro": "#8FB8E0", "azul cielo": "#87CEEB", "azul klein": "#0047AB", "azul petroleo": "#0B4F5E",
    "azul atardecer": "#5C7FA6", "azul empolvado": "#B0C4DE", "azul real": "#2455C6", "azul mar": "#2A6F97",
    "verde": "#3F7D4A", "green": "#3F7D4A",
    "verde militar": "#556B2F", "verde oliva": "#6B7A3E", "oliva": "#6B7A3E", "verde pino": "#1F4A3D",
    "verde botella": "#0B3D2E", "verde agua": "#8FD9C4", "verde lima": "#B7D948", "verde manzana": "#8DC63F",
    "verde menta": "#A8E6CF", "verde claro": "#9AD3A0", "verde oscuro": "#1E3D25",
    "rojo": "#C0272D", "red": "#C0272D",
    "rosa": "#E8A0BF", "rosa maquillaje": "#E7A9A0", "fucsia": "#D6006D",
    "morado": "#6A3D9A", "purpura": "#6A3D9A", "violeta": "#7F4FA3", "lavanda": "#B79CD2", "lila": "#C8A2C8",
    "amarillo": "#E8C547", "mostaza": "#C9A227",
    "naranja": "#D96B2B", "teja": "#B5502E",
    "marron": "#6B4A32", "brown": "#6B4A32", "marron claro": "#9C7A5B", "marron chocolate": "#3D2A1F",
    "chocolate": "#3D2A1F", "camel": "#C19A6B", "canela": "#A0632D", "khaki": "#8B8464", "caqui": "#8B8464",
    "beige": "#E3D5B8", "arena": "#D8C7A1", "crudo": "#EDE4D3", "stone": "#B9AF9A", "piedra": "#B9AF9A",
    "burdeos": "#7A1F3D", "burgundy": "#7A1F3D", "wine": "#5E1A2E", "vino": "#5E1A2E", "granate": "#7B1E28",
    "berenjena": "#4B2E39", "turquesa": "#2FB6A9", "petroleo": "#0B4F5E", "indigo": "#3B3170",
    "dorado": "#C9A227", "gold": "#C9A227", "oro": "#C9A227", "oro rosa": "#B76E79", "oro blanco": "#E8E2D6",
    "plateado": "#C0C0C0", "silver": "#C0C0C0", "plata": "#C0C0C0", "bronce": "#8C6A4A", "champagne": "#F0DFC8"
  };

  function normalizar(s) {
    return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }
  function buscarColor(nombre) {
    var n = normalizar(nombre);
    if (diccionario[n]) return diccionario[n];
    for (var key in diccionario) {
      if (n.indexOf(key) > -1) return diccionario[key];
    }
    return null;
  }

  document.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
    var label = grupo.querySelector('.mt-opcion-label');
    if (!label) return;
    var texto = normalizar(label.textContent);
    if (texto.indexOf('color') === -1) return;
    grupo.querySelectorAll('.mt-opcion-valor').forEach(function (boton) {
      var nombreValor = boton.getAttribute('data-valor') || boton.textContent;
      var color = buscarColor(nombreValor);
      if (color) {
        boton.style.setProperty('--mt-swatch', color);
        boton.classList.add('mt-tiene-swatch');
      }
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-mt-delay') || 0;
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, Number(delay));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var minis = galeria.querySelectorAll('[data-mt-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-mt-full');
        if (!full) return;
        principal.src = full;
        minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
        mini.classList.add('mt-mini-activa');
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-mt-variant-id]');
    var precioEl = root.querySelector('[data-mt-precio]');
    var precioTachadoEl = root.querySelector('[data-mt-precio-tachado]');
    var badgeDescuentoEl = root.querySelector('[data-mt-badge-descuento]');
    var badgeOfertaEl = root.querySelector('[data-mt-badge-oferta]');
    var btn = root.querySelector('[data-mt-anadir]');
    var btnTexto = root.querySelector('[data-mt-anadir-texto]');
    var opciones = root.querySelectorAll('[data-mt-opcion]');
    var imagenPrincipal = root.querySelector('[data-mt-imagen-principal]');
    var miniaturas = root.querySelectorAll('[data-mt-mini]');
    var stockEl = root.querySelector('[data-mt-stock]');

    function mensajeStock(cantidad) {
      return 'Solo quedan ' + cantidad + ' en stock';
    }

    function seleccionActual() {
      var seleccion = [];
      opciones.forEach(function (grupo) {
        var activo = grupo.querySelector('.mt-activa');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function buscarVariante(seleccion) {
      return variantes.find(function (v) {
        return v.opciones.every(function (val, i) { return val === seleccion[i]; });
      });
    }

    function money(cents) {
      return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function actualizar() {
      var seleccion = seleccionActual();
      var variante = buscarVariante(seleccion);
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = money(variante.precio);
      if (precioTachadoEl) {
        if (variante.precioComparado && variante.precioComparado > variante.precio) {
          precioTachadoEl.textContent = money(variante.precioComparado);
          precioTachadoEl.style.display = '';
          if (badgeDescuentoEl) {
            var pct = Math.round(((variante.precioComparado - variante.precio) / variante.precioComparado) * 100);
            badgeDescuentoEl.textContent = '-' + pct + '%';
            badgeDescuentoEl.style.display = '';
          }
          if (badgeOfertaEl) badgeOfertaEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
          if (badgeDescuentoEl) badgeDescuentoEl.style.display = 'none';
          if (badgeOfertaEl) badgeOfertaEl.style.display = 'none';
        }
      }
      if (btn) {
        btn.disabled = !variante.disponible;
        if (btnTexto) btnTexto.textContent = variante.disponible ? btnTexto.getAttribute('data-texto-disponible') : btnTexto.getAttribute('data-texto-agotado');
      }
      if (stockEl) {
        var cantidad = variante.inventario;
        if (variante.inventarioRastreado === 'shopify' && typeof cantidad === 'number' && cantidad > 0 && cantidad <= 8) {
          stockEl.textContent = mensajeStock(cantidad);
          stockEl.hidden = false;
        } else {
          stockEl.hidden = true;
        }
      }
      if (variante.imagen && imagenPrincipal) {
        imagenPrincipal.src = variante.imagen;
        miniaturas.forEach(function (m) {
          m.classList.toggle('mt-mini-activa', m.getAttribute('data-mt-full') === variante.imagen);
        });
      }
      opciones.forEach(function (grupo, i) {
        grupo.querySelectorAll('[data-valor]').forEach(function (boton) {
          var prueba = seleccion.slice();
          prueba[i] = boton.getAttribute('data-valor');
          var existe = variantes.some(function (v) {
            return v.opciones.every(function (val, j) { return val === prueba[j]; });
          });
          boton.disabled = !existe;
        });
      });
    }

    opciones.forEach(function (grupo) {
      grupo.querySelectorAll('[data-valor]').forEach(function (boton) {
        boton.addEventListener('click', function () {
          if (boton.disabled) return;
          grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('mt-activa'); });
          boton.classList.add('mt-activa');
          var swatchImg = boton.querySelector('img');
          if (swatchImg && imagenPrincipal) imagenPrincipal.src = swatchImg.src;
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initNewsletter() {
  document.querySelectorAll('[data-mt-newsletter]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var msg = form.querySelector('[data-mt-news-msg]');
      if (form.getAttribute('action') && form.getAttribute('action').indexOf('/contact') === -1) return;
      if (msg) {
        e.preventDefault();
        msg.textContent = msg.getAttribute('data-texto-gracias') || '¡Gracias por suscribirte!';
        msg.style.display = 'block';
        form.reset();
      }
    });
  });
}
